/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerUserUserType } from './FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerUserUserType';
import {
    FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerUserUserTypeFromJSON,
    FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerUserUserTypeFromJSONTyped,
    FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerUserUserTypeToJSON,
} from './FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerUserUserType';

/**
 * 
 * @export
 * @interface FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerUser
 */
export interface FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerUser {
    /**
     * 
     * @type {string}
     * @memberof FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerUser
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerUser
     */
    first_name?: string;
    /**
     * 
     * @type {string}
     * @memberof FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerUser
     */
    last_name?: string;
    /**
     * 
     * @type {string}
     * @memberof FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerUser
     */
    title?: string;
    /**
     * 
     * @type {FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerUserUserType}
     * @memberof FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerUser
     */
    user_type?: FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerUserUserType;
    /**
     * 
     * @type {string}
     * @memberof FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerUser
     */
    photo_url?: string;
}

/**
 * Check if a given object implements the FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerUser interface.
 */
export function instanceOfFindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerUser(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerUserFromJSON(json: any): FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerUser {
    return FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerUserFromJSONTyped(json, false);
}

export function FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerUserFromJSONTyped(json: any, ignoreDiscriminator: boolean): FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerUser {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'first_name': !exists(json, 'first_name') ? undefined : json['first_name'],
        'last_name': !exists(json, 'last_name') ? undefined : json['last_name'],
        'title': !exists(json, 'title') ? undefined : json['title'],
        'user_type': !exists(json, 'user_type') ? undefined : FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerUserUserTypeFromJSON(json['user_type']),
        'photo_url': !exists(json, 'photo_url') ? undefined : json['photo_url'],
    };
}

export function FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerUserToJSON(value?: FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerUser | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'first_name': value.first_name,
        'last_name': value.last_name,
        'title': value.title,
        'user_type': FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerUserUserTypeToJSON(value.user_type),
        'photo_url': value.photo_url,
    };
}

